
import React from 'react';
import TotalConsumptionsComparison from './consumption/TotalConsumptionsComparison';
import EnergySavingsCard from './consumption/EnergySavingsCard';
import EfficiencyRecommendationsCard from './consumption/EfficiencyRecommendationsCard';

const ConsumptionTab = () => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        <TotalConsumptionsComparison />
        <EnergySavingsCard />
      </div>
      
      <EfficiencyRecommendationsCard />
    </div>
  );
};

export default ConsumptionTab;
